import { buildImageGenerationResult } from '@/hooks/generation/image/build-image-generation-result';
import { buildVideoGenerationResult } from '@/hooks/generation/video/build-video-generation-result';

export function buildGenerationResult(data) {
  const videoResult = buildVideoGenerationResult(data);
  if (videoResult) {
    return videoResult;
  }

  const imageResult = buildImageGenerationResult(data);
  if (imageResult) {
    return imageResult;
  }

  console.error('Unknown API response format:', data);
  throw new Error('API returned unknown format');
}
